import React, { useState, useEffect } from 'react'
import { BeatLoader } from 'react-spinners'
import styles from './styles.module.css'

// component function
export default function News() {

	const [latestPost, setLatestPost] = useState([])
	const [loading, setLoading] = useState(true)
	const postsListUrl = 'https://flowsam.ai/news'

	// fetch news posts from Flowsam WordPress site
	useEffect(() => {
		fetch('https://flowsam.ai/wp-json/wp/v2/posts')
		.then(res => res.json())
		.then(data => {
			data.length && setLatestPost(data[0])
			setLoading(false)
		})
		.catch(err => console.error(err))
	}, []);

	// format post date
	function formatPostDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		return new Intl.DateTimeFormat('en-GB', {
			day: '2-digit',
			month: 'short',
			year: 'numeric'
		}).format(date);
	}

	// open news list page in new tab
	function goNews() {
		const a = document.createElement('a');
		a.href = postsListUrl;
		a.target = '_blank';
		a.rel = 'noopener';
		a.click();
	}

	const newsContent = (loading ?
		<>
			<div className={styles.newsContainer + ' ' + styles.loading}>
				<BeatLoader color={'var(--bg3-color)'} />
			</div>
		</>
		:
		latestPost?.length === 0 ?
		<>
			<div className={styles.newsContainer + ' ' + styles.loading}>
				<div className={styles.newsText}>No news available</div>
			</div>
		</>
		:
		<>
			<div className={styles.newsContainer} onClick={goNews}>
				<div className={styles.newsDate}>{formatPostDate(latestPost?.date)}</div>
				<div className={styles.newsTitle}>{latestPost?.title?.rendered}</div>
				<div className={styles.newsText}>{latestPost?.excerpt?.plain}</div>
				<div className={styles.cta}>Read more &gt;</div>
			</div>
		</>
	)

	return (
		<div className={styles.container}>
			<div className={styles.heading}>News</div>
			{newsContent}
		</div>
	)
}
